import type { SerializedStyles } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';
import { SvgApple } from '@coursera/coursera-ui/svg';

import SocialButton from 'bundles/authentication-common/components/sso/SSOButton';
import withSocialSSO from 'bundles/authentication-common/hocs/SocialSSO';
import useTrackClickButton from 'bundles/authentication-common/hooks/useTrackClickButton';
import withSingleTracked from 'bundles/common/components/withSingleTracked';

import _t from 'i18n!nls/authentication';

const TrackedSocialButton = withSingleTracked({ type: 'BUTTON' })(SocialButton);

type Props = {
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  btnLabel?: string;
  customStyles?: SerializedStyles;
  iconColor?: string;
};

const Apple = React.forwardRef(
  ({ className, disabled = false, onClick, btnLabel, customStyles, iconColor }: Props, ref: React.Ref<HTMLElement>) => {
    const { trackButton } = useTrackClickButton();
    const handleOnClick = () => {
      trackButton({ name: 'signup_with_apple' });
      onClick?.();
    };
    return (
      <TrackedSocialButton
        className={className}
        customStyles={customStyles}
        disabled={disabled}
        icon={SvgApple}
        iconColor={iconColor}
        onClick={handleOnClick}
        trackingName="continue_with_apple_auth_btn"
        _refAltAsTrueRef={ref}
      >
        {btnLabel ?? (
          <Typography2 component="span" variant="actionSecondary" color="inherit">
            {_t('Continue with Apple')}
          </Typography2>
        )}
      </TrackedSocialButton>
    );
  }
);
Apple.displayName = 'Apple';

export default withSocialSSO(Apple, 'apple');
